import swipeDetect from 'swipe-detect';
import intersect from '@alpinejs/intersect';
import { marked } from 'marked';
/**
 * Will revisit this after migration to vite
 *
 */
//
// import { Livewire, Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';
//
// Alpine.magic('clipboard',
//     (el) => {
//         return (subject) => {
//             try {
//                 navigator.clipboard.writeText(subject);
//
//                 const copied = document.createElement('p');
//                 const alertMessage = document.getElementById('copied-alert-message');
//                 if(alertMessage) {
//                     alertMessage.classList.remove('hidden');
//                     setTimeout(() => {
//                         alertMessage.classList.add('hidden');
//                     }, 2000);
//                 }
//             } catch (err) {
//                 console.error('Failed to copy: ', err);
//             }
//         }
//     });
//
// Livewire.start()


/*
* Temporary hack to get the clipboard magic working
* */
document.addEventListener('alpine:init', () => {
    Alpine.magic('clipboard',
    (el) => {
        return (subject) => {
            try {
                navigator.clipboard.writeText(subject);
                const alertMessage = document.getElementById('copied-alert-message');
                if(alertMessage) {
                    alertMessage.classList.remove('hidden');
                    setTimeout(() => {
                        alertMessage.classList.add('hidden');
                    }, 2000);
                }
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        }
    });

    Alpine.directive('swipe', (elem, { value, modifiers, expression }, { evaluateLater, cleanup }) => {
            const evaluate = expression ? evaluateLater(expression) : () => {}
            const callback = (arg) => {
                evaluate(() => {}, { scope: {}, params: [arg] });
            }
            const threshold = (modifiers[0] === 'threshold' &&
                                       (modifiers[1] || '').endsWith('px') &&
                                       Number(modifiers[1].replace('px', ''))) || 10;

            const detectorInstance = swipeDetect(elem,
                function (direction) {
                    if (!value) {
                        callback(direction)
                        return
                    }
                    if (direction === value) {
                        callback(direction)
                        return
                    }
                }, threshold);

            cleanup(() => {
                detectorInstance.disable();
            })
        })

    Alpine.plugin(intersect);

    Alpine.directive('markdown', (el, { expression }, { evaluateLater, effect }) => {
        let getContent = evaluateLater(expression)

        effect(() => {
            getContent(content => {
                el.innerHTML = marked.parse(content || '')
            })
        })
    })
})
